import { combineReducers } from 'redux';

import consultaNomeSocial from './consultaNomeSocial/reducer';

export default combineReducers({
	consultaNomeSocial,
});
